export default {
  printElement(el) {
    const head = document.head;
    const printWindow = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
    );

    printWindow.document.open();
    printWindow.document.write(
      `<head>${head.innerHTML}</head>`,
      `<body>${el.outerHTML}</body>`
    );
    printWindow.document.close();

    printWindow.addEventListener("load", function() {
      printWindow.focus();
      printWindow.print();
    });
  },
  printComponent(id) {
    const el = document.getElementById(id);
    const head = document.head;

    const printWindow = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
    );

    printWindow.document.open();
    printWindow.document.write(
      `<head>${head.innerHTML}</head>`,
      `<body>${el.outerHTML}</body>`
    );
    printWindow.document.close();

    printWindow.addEventListener("load", function() {
      printWindow.focus();
      printWindow.print();
    });
  },
};
